import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';

export const LoadEstimationTargetSampleColumns = createAction(
  '[Estimation Target Sample]: Load Columns',
  props<{ columns: { [label: string]: string } }>(),
);

export const LoadEstimationTargetSampleInit = createAction('[Estimation Target Sample]: Estimation Target Sample Init');


export const LoadEstimationTargetSampleSuccess = createAction(
    '[Estimation Target Sample]: Estimation Target Sample Success',
    props<{ data: any }>(),
);

export const LoadEstimationTargetSampleFailure = createAction(
    '[Estimation Target Sample]: Estimation Target Sample Success',
    props<{ error: HttpErrorResponse }>(),
);

export const CloseEstimationTargetSampleModal = createAction('[Estimation Target Sample]: Close Modal')

export const LoadEstimationTargetSampleCountInit = createAction('[Estimation Target Sample]: Estimation Target Sample Count');

export const LoadEstimationTargetSampleCountSuccess = createAction('[Estimation Target Sample]: Estimation Target Sample Count Success',  props<{ count: number }>());

export const LoadEstimationTargetSampleCountFailure = createAction('[Estimation Target Sample]: Estimation Target Sample Count Failure', props<{ error: HttpErrorResponse }>());

export const PagingChanged = createAction('[Estimation Target Sample]: Paging Changed', props<{ paginator: Paginator }>());
